import { faClipboard } from '@fortawesome/pro-solid-svg-icons';

import { useTranslate } from '@growtherapy/i18n';
import { Tag } from '@growtherapy/sprout-ui';

import { ControlPanelButton, ControlPanelButtonTooltip } from '../../components/ControlPanelButton';
import { DrawerButton } from '../../components/DrawerButton';
import { IconMenuItem } from '../../components/IconMenuItem';
import { VisitorDrawerState } from '../state';

export type VisitorMeasureDrawerControlProps = {
  className?: string;
  drawerId: string;
  isDrawerOpen: boolean;
  onClick: () => void;
  showVisualIndicator: boolean;
  tooltipText: string;
};
export function VisitorMeasureDrawerControl({
  className,
  drawerId,
  isDrawerOpen,
  onClick,
  showVisualIndicator,
  tooltipText,
}: VisitorMeasureDrawerControlProps) {
  return (
    <div className={className}>
      <ControlPanelButtonTooltip childIsInteractive text={tooltipText}>
        <DrawerButton
          forDrawerStates={VisitorDrawerState.PENDING_FORMS}
          aria-label={tooltipText}
          aria-expanded={isDrawerOpen}
          aria-controls={drawerId}
          iconDefinition={faClipboard}
          as={ControlPanelButton}
          onClick={onClick}
          showVisualIndicator={showVisualIndicator}
        />
      </ControlPanelButtonTooltip>
    </div>
  );
}

export type VisitorMeasureDrawerControlMenuItemProps = {
  className?: string;
  drawerId: string;
  helperText: string;
  isDrawerOpen: boolean;
  onClick: () => void;
  outstandingMeasuresCount: number;
};

export function VisitorMeasureDrawerControlMenuItem({
  className,
  drawerId,
  helperText,
  isDrawerOpen,
  onClick,
  outstandingMeasuresCount,
}: VisitorMeasureDrawerControlMenuItemProps) {
  const t = useTranslate();
  return (
    <IconMenuItem
      aria-controls={drawerId}
      aria-expanded={isDrawerOpen}
      onClick={onClick}
      className={className}
      icon={faClipboard}
    >
      <span className='sr-only'>{helperText}</span>
      <span aria-hidden>{t('telehealth-core:controls.measures')}</span>
      {outstandingMeasuresCount > 0 && (
        <Tag use='lilac' aria-hidden>
          {outstandingMeasuresCount}
        </Tag>
      )}
    </IconMenuItem>
  );
}
